export default __webpack_public_path__ + "static/media/no_of_days_celebrate.3d71d3a3.svg";